/**
 * Created by Mark on 18/04/2017.
 */


import React  from 'react';

import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import ListItem from '../components/lists/list-item.js';
import Wizard from '../components/wizard/wizard.js';
import Steps  from '../components/wizard/create-class-steps';
import Profile from '../components/profile/profile.js'
import { Link , hashHistory} from 'react-router'
import { FormattedMessage } from 'react-intl';
import About from '../components/profile/profile-tabs/about-class-panel.js';
import StudentManagement from '../components/profile/profile-tabs/student-class-panel.js';
import Homework from '../components/profile/profile-tabs/homework-class-panel.js';
import Recent from '../components/profile/profile-tabs/recent-class-panel.js';
import Scores from '../components/profile/profile-tabs/class-scores-panel.js';
import ClassService from '../services/classes-service.js';
import ClassStore from '../store/classes-store.js';
import {Button , Breadcrumb} from 'react-bootstrap';
import LanguageServices from '../services/language-services.js';
import LanguageStore from '../store/language-store.js';
import {Modal , ControlLabel , Row , Col , FormGroup , FormControl} from 'react-bootstrap';
import AuthneticationStore from "../store/authentication-store.js";
import PDF from 'react-pdf-js';
import LanguageSelector from '../components/inputs/language-selector.js'
import StaffSelector from '../components/inputs/staff-selector.js'
import GeneratePDF from '../classes/pdf_generate.js';
export default class ClassesProfileComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            classInformation: {},
            showComfirmation:false,
            showEdit:false,
        };
        this.PDFgen = new GeneratePDF();

        this.handelClassNameChange = this.handelClassNameChange.bind(this);
        this.handelStaffChange = this.handelStaffChange.bind(this);
        this.handelLanguageChange = this.handelLanguageChange.bind(this);
    }

    handelLanguageChange(language){
        console.log(language);

        var languages = [];

        for(var idx = 0 ; idx < language.length; idx++)
        {
            languages.push(LanguageStore.getLanguage(language[idx].value));
        }

        if(languages.length <= 0) return;
        this.setState({languages:languages})
    }

    handelClassNameChange(e){

        var classInformation = this.state.classInformation;
            classInformation.name = e.target.value;

        this.setState({
            classInformation:classInformation
        })
    };

    handelStaffChange(staff){


        var entry = [];

        for(var index in staff)
        {
            var member = staff[index];
            entry.push({uid:member.uid , name:member.label})
        }


        var classInformation = this.state.classInformation;
            classInformation.teachers = entry;

        if(classInformation.teachers.length <= 0) return;

        this.setState({classInformation:classInformation});
    }

    componentDidMount() {
        ClassService.getClass(this.props.params.classID)
    }

    componentWillMount(){
        ClassStore.on("UPDATE_CLASS" , () => {
            this.setState({classInformation:ClassStore.class});

            if(ClassStore.class.allLanguages == 1)
            {
                this.setState({classInformation:ClassStore.class});

                LanguageStore.on("CHANGE" , () => {
                    this.setState({languages:LanguageStore.getLearningLanguage()});
                });

                LanguageServices.getAllAvailableLanguages()
            }
            else
            {
                LanguageServices.getAllAvailableLanguages().then(function(){

                    var languages = ClassStore.class.languages.map(function(language){
                        return  LanguageStore.getLanguage(language.ietf);
                    });

                    console.log(languages)
                    this.setState({classInformation:ClassStore.class , languages:languages || []});
                }.bind(this));
            }

        });


    }

    deleteObject(){

        ClassService.deleteClass(this.props.params.classID).then(function(complete){
            hashHistory.push('/class/management')
        })
    }

    showComfirmation(){
        this.setState({showModal:true});
    }

    downloadClass(){
       this.PDFgen.generateClassPDF(this.state.classInformation.name, this.state.classInformation.students);
    }

    classSidePanel(){

        if(!this.state.classInformation) return;
        if(!this.state.languages) return;

        const teachers = this.state.classInformation.teachers.map(function(teacher){
            return <li><i className="zmdi zmdi-face"></i>{teacher.name}</li>
        });

        const languages = this.state.languages.map(function(language){
            let ietf = language ? language.ietf : 'en'
            return <a  className="col-xs-2 m-5">
                <img className="avatar-img" src={"img/flags/"+ietf+".png"} alt=""/>
            </a>
        });

        let deleteButton = null;
        let editButton  = null;
        let studentLoginButton  = null;
        if(AuthneticationStore.hasCreatePermissions())
        {
            deleteButton = <div className="pmo-block p-r-20 p-l-20 p-t-0">
                <Button onClick={this.showComfirmation.bind(this)} className="btn-block btn-primary"><FormattedMessage id={ 'ui-346' } defaultMessage={ 'Delete Class' }/></Button>
            </div>

            editButton = <div className="pmo-block p-r-20 p-l-20 p-t-0 p-b-0">
                <Button onClick={this.toggleEdit.bind(this)} className="btn-block btn-primary"><FormattedMessage id={ 'ui-663' } defaultMessage={ 'Edit' }/></Button>
            </div>
        }
        studentLoginButton = <div className="pmo-block p-r-20 p-l-20 p-t-0 p-b-0">
            <Button onClick={this.downloadClass.bind(this)} className="btn-block btn-primary"><FormattedMessage id="ui-2128" defaultMessage="Download Student Logins" /></Button>
        </div>

        const assignmentButton = <div className="pmo-block p-r-20 p-l-20 p-t-0">
            <Button onClick={this.toggleEdit.bind(this)} className="btn-block btn-primary"><FormattedMessage id={ 'ui-886' } defaultMessage={ 'New Assignment' }/></Button>
        </div>


        return<div>
                <div className="pmo-pic">
                    <div className="p-t-20 pmo-stat palette-Branding secondary bg">
                        <h4 className="m-0 c-white">{this.state.classInformation.name}</h4>
                    </div>
                </div>
                    {editButton}
                    {studentLoginButton}
                    {deleteButton}
                <div>
                    <div className="pmo-block pmo-contact hidden-xs p-t-0 p-b-10">
                        <h2><FormattedMessage id={ 'ui-589' } defaultMessage={ 'Teachers' }/></h2>
                        <ul>
                            {teachers}
                        </ul>
                    </div>

                    <div className="pmo-block pmo-contact hidden-xs p-t-0 p-b-10">
                        <h2><FormattedMessage id={ 'ui-839' } defaultMessage={ 'Main Languages' }/></h2>

                        <div className="pmob-body">
                            <div className="row">
                                {languages}
                            </div>
                        </div>
                    </div>

                    <div className="pmo-block pmo-contact hidden-xs p-t-0 p-b-10">
                        <h2><FormattedMessage id={ 'ui-823' } defaultMessage={ 'Total Students' }/></h2>
                        <ul>
                            {this.state.classInformation.studentsTotal}
                        </ul>
                    </div>

                </div>
            </div>
    }

    getBreadCrumb(){

        if(!this.state.classInformation) return;
        if(!this.state.languages) return;

        return  <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="#/class/management">
            <FormattedMessage id={ 'ui-782' } defaultMessage={ '' }/>
        </Breadcrumb.Item>
            <Breadcrumb.Item active>
                {this.state.classInformation.name}
            </Breadcrumb.Item>
        </Breadcrumb>
    }

    close(){
        this.setState({showModal:false});
    }

    toggleEdit(){
        this.setState({showEdit:!this.state.showEdit});
    }

    saveEdit(String){


        ClassService.editClass(this.props.params.classID , this.state.classInformation.name , false , this.state.languages.map(function(language){ return language.ietf}) , this.state.classInformation.teachers.map(function(teacher){ return teacher.uid})).then(function(){

        });

        this.setState({showEdit:false})
    }

    getStaffValues(){
        return this.state.classInformation.teachers.map(function(staff){
            return  { uid:staff.uid, value: staff.uid, label: staff.name}
        });
    }

    getLanguageValues(){

        let languages = [];
        for(var idx = 0 ; idx <  this.state.languages.length; idx++ )
        {
            if(!this.state.languages[idx]) continue;
            if(!this.state.languages[idx].ietf) continue;

            let language = this.state.languages[idx];
            languages.push({ value: language.ietf, label: language.getName()})
        }

        return languages;
    }

    render(){

        if(!this.state.classInformation) return null;
        if(!this.state.languages) return null;

        return (<Layout>{this.getBreadCrumb()}

            <Modal show={this.state.showEdit} onHide={this.toggleEdit.bind(this)}>
                <Modal.Header>
                    <Modal.Title><FormattedMessage id={ 'ui-663' } defaultMessage={ 'Edit' }/></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <FormGroup className="fg-line fg-toggled">
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-452' } defaultMessage={ 'Class Name' }/>
                                </ControlLabel>
                                <FormControl  value={this.state.classInformation.name} type="text" onChange={this.handelClassNameChange}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup className="fg-line fg-toggled">
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-866' } defaultMessage={ 'Share Class' }/>
                                </ControlLabel>
                                <StaffSelector multi value={this.getStaffValues()} onChange={this.handelStaffChange}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup className="fg-line fg-toggled">
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-839' } defaultMessage={ 'Learning Languages' }/></ControlLabel>
                                <LanguageSelector onSelect={this.handelLanguageChange} multi value={this.getLanguageValues()} />
                            </FormGroup>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.toggleEdit.bind(this)}><FormattedMessage id={ 'ui-41' } defaultMessage={ 'Cancle' }/></Button>
                    <Button onClick={this.saveEdit.bind(this)} bsStyle="primary"><FormattedMessage id={ 'ui-336' } defaultMessage={ 'Save' }/></Button>
                </Modal.Footer>

            </Modal>

            <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                <Modal.Header>
                    <Modal.Title><FormattedMessage id={ 'ui-346' } defaultMessage={ 'Delete Class' }/></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <FormattedMessage id={ 'ui-667' } defaultMessage={ 'Are You Sure' }/>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.close.bind(this)}><FormattedMessage id={ 'ui-41' } defaultMessage={ 'Cancel' }/></Button>
                    <Button onClick={this.deleteObject.bind(this)} bsStyle="primary"><FormattedMessage id={ 'ui-444' } defaultMessage={ 'Delete' }/></Button>
                </Modal.Footer>

            </Modal>
            <Profile name="" panelIndex={this.props.params.panel} data={{classID:this.props.params.classID}} sidePanel={this.classSidePanel.bind(this)} stepsNavigation={true} panels={[About , Recent , StudentManagement  , Scores]} /></Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/classes-profile.js